module.exports = __webpack_public_path__ + "static/media/SIX.2aebe7ec.png";